/* tslint:disable */
/* eslint-disable */
/**
 * TurboClaim API
 * TurboClaim API for insurance claim management. Includes claims, documents, estimates, supplements, billing, and chat operations. Authentication is JWT-based bearer token. 
 *
 * The version of the OpenAPI document: 1.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface WidgetLinkInput
 */
export interface WidgetLinkInput {
    /**
     * 
     * @type {string}
     * @memberof WidgetLinkInput
     */
    label: string;
    /**
     * 
     * @type {string}
     * @memberof WidgetLinkInput
     */
    url: string;
}

/**
 * Check if a given object implements the WidgetLinkInput interface.
 */
export function instanceOfWidgetLinkInput(value: object): value is WidgetLinkInput {
    if (!('label' in value) || value['label'] === undefined) return false;
    if (!('url' in value) || value['url'] === undefined) return false;
    return true;
}

export function WidgetLinkInputFromJSON(json: any): WidgetLinkInput {
    return WidgetLinkInputFromJSONTyped(json, false);
}

export function WidgetLinkInputFromJSONTyped(json: any, ignoreDiscriminator: boolean): WidgetLinkInput {
    if (json == null) {
        return json;
    }
    return {
        
        'label': json['label'],
        'url': json['url'],
    };
}

export function WidgetLinkInputToJSON(json: any): WidgetLinkInput {
    return WidgetLinkInputToJSONTyped(json, false);
}

export function WidgetLinkInputToJSONTyped(value?: WidgetLinkInput | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'label': value['label'],
        'url': value['url'],
    };
}

